export interface AuthWithCodeReq {
  clientId: string;
  code: string;
}
